import mixpanel from 'mixpanel-browser';

mixpanel.init('4cd697e8ca7470752857c1243fff22dc'); 

export default mixpanel;
